__turbopack_context__.v({
  "blok-big-title": "DoubleHeroBlok-module__a3BpoW__blok-big-title",
  "blok-subtitle": "DoubleHeroBlok-module__a3BpoW__blok-subtitle",
  "blok-title": "DoubleHeroBlok-module__a3BpoW__blok-title",
  "root": "DoubleHeroBlok-module__a3BpoW__root",
  "slide": "DoubleHeroBlok-module__a3BpoW__slide",
});
